module.exports = __webpack_public_path__ + "static/media/mentor-2.d8e177fc.png";